import React, { useState, useEffect } from 'react'
import { connect, useSelector } from "react-redux";
import Addfiles from "../../common/Addfiles";


export function InvoiceStep3Pay(props) {

const [paymentSent, setPaymentSent] = useState(false);
const [notes, setNotes] = useState(null);
const invoice = useSelector( (state) => state.invoices.invoice );

const handleChangeValue = (e) => {
    setPaymentSent(true);
}
const handleAddNotes = (e) => {
    setNotes(e.target.value);
}
const handleSubmit = (e) => {
    e.preventDefault();
    const vendorName = invoice.company_vendor?.name ? invoice.company_vendor.name : "Vendor";
    props.handleResponseSubmit({stage: "PU", notes: notes, }, `${vendorName} notified: payment has been sent`)
    // props.respondToInvoice(invoice.invoice_id, {stage: "PU", notes: notes}, "${invoice.company_vendor.name} notified: payment has been sent")
}

    return (
        <form onSubmit={(e) => handleSubmit(e)} className="gap-above-m gap-below-s">
            <div className="checkbox-wrapper gap-below-xs" >
                <input 
                    className="typical-checkbox"
                    type="checkbox"
                    id="payment_sent"
                    name="payment_sent"
                    checked={paymentSent}
                    onChange={() => setPaymentSent(!paymentSent)}
                />
                <label htmlFor="payment_sent" className="content2 light-black multiline" >Payment has been sent</label>
            </div>
            <div className="gap-above-s gap-below-s">
                <p className="content2 heavy-grey gap-below-xs">Supporting Documents</p>
                <Addfiles 
                    uploadTitle="+ Add Supporting Docs"
                    selectedFiles={props.selectedFilesAdditional}
                    handleDrop={props.handleDrop}
                    removeSelectedFile={props.removeSelectedFile}
                    // removeUploadedFile={removeUploadedFileInvoiceAdditional}
                    // removedFiles={removedFilesInvoiceAdditional}
                    maxSize={10485760}
                    maxFiles={0}
                    multiple={true}
                    accept=""
                />
            </div>
            <div className="inputs-wrapper" >
                <div className="input-basic textarea addspace gap-below-xs">	
                    <label className="textarea" htmlFor="notes">Notes (optional)</label>			
                    <textarea type="text" name="notes" id="notes" rows="3" onChange={(e) => handleAddNotes(e)}/>
                </div>
            </div>
            <div className="gap-above-s">
                <button id="invoice_pay_confirm" className="btn pri min-width" type="submit" disabled={!paymentSent || props.isSubmitting} >{props.isSubmitting ? "Please wait..." : "Confirm"}</button>
            </div>
        </form> 
    )
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(InvoiceStep3Pay);
